import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import { Create } from "../../../utils/apis/master/policy/policy";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS } from "../../../utils/common";
import { Context } from "../../../utils/context";
import Select from "react-select";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import JoditEditor from "jodit-react";
function Add(props) {
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const { UnauthorizedLogOut } = useContext(Context);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    watch,trigger,setValue,control
  } = useForm();
  const descriptionValue = watch("description");
  useEffect(() => {
    register("description", {
      required: "description is required.",
    });
  }, [register]);
  const onSubmit = async (data) => {
    try {
      
      const response = await Create(data);

      if (HTTPS.ALREADY_REPORTED.code !== response?.data?.code) {
        await setShowModal({
          code: response.data.code,
          message: response.data.data,
        });
        setTimeout(() => {
          setShowModal(0);
          props.onHide();
          reset();
        }, 2000);
      } else {
        setError("type", {
          type: "manual",
          message: response?.data?.errors || "An error occurred",
        });
      }
    } catch (error) {
      setError("type", {
        type: "manual", // Optional but helps to indicate it's a manual error
        message: error?.response?.data?.errors,
      });
      await UnauthorizedLogOut(error);
      console.error(error);
    }
  };

  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal_Heading modalHeading={"Add Policy"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Type*</Form.Label>
                        <Controller
                          name="type"
                          {...register("type", {
                            required: "type",
                          })}
                          control={control}
                          render={({ field }) => (
                            <Select
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderColor: errors.explore_type_id
                                    ? "red"
                                    : baseStyles,
                                }),
                              }}
                              {...field}
                              options={[
                                { label: "PrivacyPolicy", value: "PrivacyPolicy" },
                                { label: "Term&Services", value: "Term&Services" }, 
                                { label: "Term&Condition", value: "Term&Condition" }
                               
                              ]}
                            />
                          )}
                        />
                        {errors.type && (
                          <span className="text-danger">
                            {errors.type.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Description*</Form.Label>
                        <Controller
                          name="description" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{
                            required: "description is required",
                          }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={descriptionValue || ""}
                              onBlur={(newContent) => {
                                setValue("description", newContent);
                                trigger("description");
                              }}
                            />
                          )}
                        />
                        {errors.description && (
                          <span className="text-danger">
                            {errors.description.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      className="search-btn mx-2"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      className="reset-btn mx-2"
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />

        {/* <Successfull_Modal
        message={"abc"}
        subMessage={"xyz"}
          show={modalShow}
          onHide={() => setModalShow(false)}
        /> */}
      </section>
    </>
  );
}

export default Add;
